
<p-dialog
  header="{{ headerTitle }}"
  [(visible)]="currentDiplayValue"
  [modal]="true"
  [responsive]="true"
  [style]="{width: '85vw'}"
  (onHide)="cancelManualPopup()"
  [draggable]="false" appendTo="body"
  [baseZIndex]="3">
  <div class="card" style="margin-bottom: 100px;">
    <p-table #accountsTable [value]="allAccounts"
      [columns]="savedAccountListCols"
      [lazy]="true"
      [scrollable]="true"
      [selectionMode]="(viewOnly || singleSelection)? 'single' :'multiple'"
      [(selection)]="selectedAccountbind"
      (onRowSelect)="onSingleRowSelect($event)"
      dataKey="id"
      styleClass="p-datatable-gridlines"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="lsttotalRecords"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="tableShowMore"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onLazyLoad)="getAllAccountsWithPagination($event)"
      [(first)]="firstPage">
        <ng-template pTemplate="caption">
          <div class="table-header p-d-flex p-ai-center">
            <p-toggleButton *ngIf="showActiveInActive" class="p-mr-2" onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
                [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActive"
                (onChange)="loadListingWithFilters()">
            </p-toggleButton>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText type="text"
                [formControl]="searchControl"
                [ngModelOptions]="{standalone: true}"
                placeholder="Search..." />
            </span>

            <div class="p-d-flex p-ai-center p-ml-auto">
              <div *ngIf="!fromProductVisibilityModule">
                <app-filters [listCols]="listColsAll" [selectedParentModule]="selectedFilterModule" (applyFiltersColumns)="applyFilters($event)"></app-filters>
              </div>
              <p-checkbox *ngIf="!singleSelection && !fromProductVisibilityModule" [(ngModel)]="selectedStore" [binary]="true" class="add-margin-right" label="Show only assigned" (onChange)="onAssignedCheckboxChange()"></p-checkbox>
              <p-button label="Setting" (click)="showSetting()"></p-button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <ng-container *ngFor="let col of columns">
              <col *ngIf="col.enabled" style="width:auto">
            </ng-container>
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngIf="accountTreeViewEnabled" id="id" style="width: 40px; max-width: 40px;"></th>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)" [pSortableColumn]="col.columnName" style="min-width:116.05px">
                    {{col.name}}
                    <p-sortIcon *ngIf="col.columnName!='tags'"
                        style="margin-right: 3px;" [field]="col.columnName" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                    <!-- <span class="pi pi-filter p-mr-2 filtericon" *ngIf=" selectedObject.id === 1"
                        [ngClass]="{'blink_me' : col.value && col.value.length > 0}"
                        (click)="$event.stopPropagation(); currentCol = col; accountTablefilters.toggle($event)">
                    </span> -->
                </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData" [ngClass]="rowData?.rowColor"
          [pSelectableRowDisabled]="fromProductVisibilityModule && (viewOnly || fromRule)">
            <!-- start for space rowexpansion -->
            <td style="width: 40px; max-width: 40px;" *ngIf="accountTreeViewEnabled" class="padding-1">
              <ng-container *ngIf="rowData.hasChildAccounts">
                  <button type="button" [pRowToggler]="rowData" pButton pRipple
                      class="p-button-text p-button-rounded p-button-plain"
                      (click)="onExpandRow(rowData.id, rowData, expanded, rowData?.rowColor)"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                  </button>
              </ng-container>
            </td>
            <!-- end for space rowexpansion -->
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)" style="text-align: left;min-width: 116.05px;word-break: break-all;">
                <ng-container *ngIf="!col?.depth; else depthTemplate">
                    <ng-container *ngIf="col.columnName =='businessName' && rowData.classificationColor">
                        <app-color-box class="colorBoxStyle" [color]="rowData.classificationColor"></app-color-box>
                    </ng-container>
                    <ng-container *ngIf="col.columnName =='tags'">
                      <ng-container *ngFor="let s of rowData?.tags; let i = index">
                          <p-tag styleClass="p-ml-1" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="(['twitter','website', 'facebook','linkedin','instagram',
                                            'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                            'contactsociallinkedin','contactsocialinstagram'].indexOf(col.columnName) >= 0
                                            || ['URL'].includes(col?.formControlType)); else elseData">
                        <a href="{{rowData[col.columnName] | url}}" target="_blank">{{ rowData[col.columnName] | shorten }}</a>
                    </ng-container>
                    <ng-container *ngIf="phoneFields.includes(col.columnName)">
                        {{ rowData[col.columnName] | phoneNumber: rowData[col.columnName+'code'] }}
                    </ng-container>
                    <ng-container *ngIf="col?.formControlType=='Percentage'">
                        {{ rowData[col.columnName] | percentageSymbol }}
                    </ng-container>
                    <ng-container *ngIf="col?.formControlType=='Currency'">
                        {{ rowData[col.columnName]  | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol }}
                    </ng-container>
                    <ng-container *ngIf="col?.formControlType=='RichText'">
                        {{ rowData[col.columnName] | removeHtmlTags | shorten }}
                    </ng-container>
                    <ng-template #elseData>
                      <ng-container *ngIf="!['Percentage','Currency','RichText'].includes(col?.formControlType) && col.columnName != 'tags' && !phoneFields.includes(col.columnName)">
                        <ng-container [ngSwitch]="col?.fieldDataType">
                          <ng-container *ngSwitchCase="'DateTime'">
                            {{ col?.isDateWithTime ? (col?.isCustom ? (rowData[col.columnName] | localDate:'dateTime':false) : (rowData[col.columnName] | localDate:'date')) : (rowData[col.columnName] | date:'MM/dd/yyyy') }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'Time'">
                            {{ rowData[col.columnName] | onlyTime }}
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            <ng-container *ngIf="col.columnName =='businessName' && rowData?.sequenceNumber && mergeAccountSequenceNumber">
                                {{ rowData?.sequenceNumber }} -
                            </ng-container>
                            <ng-container *ngIf="col.columnName =='mainCustomer' && rowData?.parentAccountSequenceNumber">
                                {{ rowData?.parentAccountSequenceNumber }} -
                            </ng-container>
                            {{rowData[col.columnName]}}
                          </ng-container>
                        </ng-container>
                      </ng-container>
                        <span *ngIf="col.columnName === 'currentStage' && rowData?.isConvertedToAccount"> *</span>
                    </ng-template>
                </ng-container>
                <ng-template #depthTemplate>
                  {{ rowData | columnName:col?.depth }}
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" #depth>
          <ng-template [ngTemplateOutlet]="Recursion"
              [ngTemplateOutletContext]="{$implicit: rowData, columns:columns}"></ng-template>
        </ng-template>

        <ng-template let-rowData let-columns="columns" #Recursion>
          <!-- @@@ {{rowData[0].childAccount}} -->
          <ng-container *ngFor="let children of rowData.childAccount">
              <ng-container *ngIf="rowData.viewDetails">
                  <tr [ngClass]="children?.rowColor" [pSelectableRow]="children" [pContextMenuRow]="children">
                      <!-- start for space rowexpansion -->
                      <td style="width: 40px; max-width: 40px;" *ngIf="accountTreeViewEnabled" class="padding-1">
                          <ng-container *ngIf="children.hasChildAccounts">
                              <button type="button" [pRowToggler]="children" pButton pRipple
                                  class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                  (click)="onExpandRow(children.id, children, children.viewDetails, children?.rowColor)"
                                  [icon]="children.viewDetails ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                              </button>
                          </ng-container>
                      </td>
                      <!-- end for space rowexpansion -->
                      <ng-container *ngFor="let col of columns;let i=index;">
                          <td *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)"
                          style="text-align: left;" [class.action-tag] = "col.columnName =='tags'">
                              <span class="account-child-level-{{(children?.childLevel||0)}}" *ngIf="col.columnName =='businessName'"></span>
                              <ng-container *ngIf="!col?.depth; else depthTemplate">
                                  <ng-container *ngIf="col.columnName =='businessName'">
                                      <app-color-box class="colorBoxStyle" [color]="children.classificationColor">
                                      </app-color-box>
                                  </ng-container>
                                  <ng-container *ngIf="col.columnName =='tags'">
                                      <ng-container *ngFor="let s of children?.tags; let i = index">
                                          <p-tag styleClass="p-ml-1" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                                      </ng-container>
                                  </ng-container>
                                  <ng-container *ngIf="(['twitter','website', 'facebook','linkedin','instagram',
                                                      'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                                      'contactsociallinkedin','contactsocialinstagram'].indexOf(col.columnName) >= 0
                                                      || ['URL'].includes(col?.formControlType));
                                                      else elseData">
                                      <a href="{{children[col.columnName] | url}}" target="_blank">{{ children[col.columnName] | shorten }}</a>
                                  </ng-container>
                                    <ng-container *ngIf="phoneFields.includes(col.columnName)">
                                        {{ children[col.columnName] | phoneNumber: children[col.columnName+'code'] }}
                                    </ng-container>
                                    <ng-container *ngIf="col?.formControlType=='Percentage'">
                                        {{ children[col.columnName] | percentageSymbol }}
                                    </ng-container>
                                    <ng-container *ngIf="col?.formControlType=='Currency'">
                                        {{ children[col.columnName] | currencySymbol }}
                                    </ng-container>
                                    <ng-container *ngIf="col?.formControlType=='RichText'">
                                        {{ children[col.columnName] | removeHtmlTags | shorten }}
                                    </ng-container>
                                  <ng-template #elseData>
                                      <ng-container *ngIf="!['Percentage','Currency','RichText'].includes(col?.formControlType) && col.columnName != 'tags' && !phoneFields.includes(col.columnName)">
                                          <ng-container [ngSwitch]="col?.fieldDataType">
                                            <ng-container *ngSwitchCase="'DateTime'">
                                                {{ col?.isDateWithTime ? (col?.isCustom ? (children[col.columnName] | localDate:'dateTime':false) : (children[col.columnName] | localDate:'date')) : (children[col.columnName] | date:'MM/dd/yyyy') }}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'Time'">
                                                {{ children[col.columnName] | onlyTime }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                              <ng-container *ngIf="col.columnName =='businessName' && children?.sequenceNumber && mergeAccountSequenceNumber">
                                                  {{ children?.sequenceNumber }} -
                                              </ng-container>
                                              <ng-container *ngIf="col.columnName =='mainCustomer' && children?.parentAccountSequenceNumber">
                                                {{ children?.parentAccountSequenceNumber }} -
                                            </ng-container>
                                              {{children[col.columnName] | shorten:27 }}
                                            </ng-container>
                                          </ng-container>
                                       </ng-container>
                                  </ng-template>
                              </ng-container>
                              <ng-template #depthTemplate>
                                  {{ children | columnName:col?.depth }}
                              </ng-template>
                          </td>
                      </ng-container>
                  </tr>
                  <ng-container *ngIf="children.childAccount && children.childAccount.length>0">
                      <ng-template [ngTemplateOutlet]="depth"
                          [ngTemplateOutletContext]="{$implicit: children, columns:columns }">
                      </ng-template>
                  </ng-container>
              </ng-container>

          </ng-container>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10">No data found.</td>
          </tr>
        </ng-template>
    </p-table>

    <p-overlayPanel #accountTablefilters appendTo="body" [showCloseIcon]="false" [dismissable]="true">
        <ng-template pTemplate>
            <div class="search-dropdown">
                <p-dropdown [options]="filterMatchModes" [(ngModel)]="selectedFilterMode" optionLabel="name"
                    (onChange)="accountsTable.filter(currentCol.value, currentCol.columnName, selectedFilterMode.value)">
                </p-dropdown>
            </div>
            <span class="p-input-icon-right">
                <i class="pi pi-times cursor-pointer" (click)="currentCol.value = '';accountsTable.filter(currentCol.value, currentCol.columnName, selectedFilterMode.value)"></i>
                <input pInputText type="text" #inputS [(ngModel)]="currentCol.value"
                (input)="accountsTable.filter(currentCol.value, currentCol.columnName, selectedFilterMode.value)"
                placeholder="Search by {{currentCol.name}}" class="p-column-filter"
                [value]="accountsTable.filters[currentCol.columnName] ? accountsTable.filters[currentCol.columnName].value : ''">
            </span>
        </ng-template>
    </p-overlayPanel>
  </div>
  <p-footer>
    <button type="button" pButton (click)="cancelManualPopup()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton *ngIf="source == 'VISIBILITY_GROUP' && !(viewOnly || singleSelection)" (click)="backToModule()" label="Back"></button>
    <button type="button" pButton *ngIf="!(viewOnly || singleSelection || (fromRule && preview))" (click)="saveAssignDataModal()" label="Save"></button>
  </p-footer>
</p-dialog>

<app-column-settings-modal-for-rules
    [displayColumnSettings]="displayColumnSettings"
    [moduleName]="selectedObject?.name"
    [disabledLabelNames]="disabledLabelNames"
    [settingsObj]="currentColList"
    [selectedView]="'list'"
    [channelId]="selectedTemplate?.id"
    [mergeAccountSequenceNumber]="mergeAccountSequenceNumber"
    (savedColumnSettings)="savedColumnSettings($event)"
    (cancelColumnSettings)="cancelColumnSettings()">
</app-column-settings-modal-for-rules>
